

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form6StatusInfoType } from '@/types/Information/Form6';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form6ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form6StatusInfoType;

}
